import {
    FETCH_PUBLICACIONES,
    FETCH_PUBLICACION,
    EDIT_PUBLICACION,
    FETCH_TIPOPUBLICACION,
    IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
    FETCH_ESTADOSVARIACIONES,
    FETCH_MARCAS,
    FETCH_DIMENSIONES,
    FETCH_CATEGORIAS,
    FETCH_MOTIVOS,
    SET_FILTRO_PUBLICACIONES,
    SE_MODIFICARON_IMAGENES,
    LOADING_PUBLICACIONES,
    FETCH_GARANTIAS
} from '../actions/types';

const initialState = {
    publicaciones: {
        elementos: [],
        cantidades: [],
        cantidadTotal: 0
    },
    loadingPublicaciones: false,
    publicacion: {},
    variacionesPublicacion: [],
    tiposPublicacion: [],
    marcas: [],
    categorias: [],
    motivosRevision: [],
    filtroPublicaciones: {},
    dimensiones: [],
    seModificaronImagenes: false,
    loadedSellerTabTipo: false,
    garantias: {}
}

export default function (state = initialState, action) {

    switch (action.type) {

        case SE_MODIFICARON_IMAGENES:
            return {
                ...state,
                seModificaronImagenes: action.payload
            };

        case SET_FILTRO_PUBLICACIONES:
            return {
                ...state,
                filtroPublicaciones: action.payload
            };

        case FETCH_PUBLICACIONES:
            return {
                ...state,
                publicaciones: action.payload
            };

        case LOADING_PUBLICACIONES:
            return {
                ...state,
                loadingPublicaciones: action.payload
            };

        case FETCH_PUBLICACION:
            return {
                ...state,
                publicacion: action.payload,
                dimensiones:action.payload.dimensiones
            };

        case EDIT_PUBLICACION:
            return {
                ...state,
                publicacion: action.payload,
                dimensiones:action.payload.dimensiones
            };

        case FETCH_TIPOPUBLICACION:
            return {
                ...state,
                tiposPublicacion: action.payload
            };
        
        case IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB:
            return{
                ...state,
                loadedSellerTabTipo: action.payload 
            };

        case FETCH_ESTADOSVARIACIONES:
            return {
                ...state,
                variacionesPublicacion: action.payload
            };

        case FETCH_MARCAS:
            return {
                ...state,
                marcas: action.payload
            };

        case FETCH_CATEGORIAS:
            return {
                ...state,
                categorias: action.payload
            };

        case FETCH_MOTIVOS:
            return {
                ...state,
                motivosRevision: action.payload 
            };

        case FETCH_DIMENSIONES:
            return {
                ...state,
                dimensiones: action.payload 
            };
        case FETCH_GARANTIAS:
            return {
                ...state,
                garantias: action.payload
            };

        default: return state
    }
}